import React, { ReactNode } from 'react'
import styled, { css } from 'styled-components'

import { giphyCharcoal, giphyLightBlue } from '@/styles/colors'

export const Input = styled.input.attrs({ type: 'checkbox' })`
  display: none;
`

const Wrapper = styled.div`
  display: none;
  padding-left: 15px;

  ${Input}:checked ~ & {
    display: block;
  }

  > ul {
    margin: 0 0 6px 0;
  }
`

export const Title = styled.a<{ isActive: boolean }>`
  cursor: pointer;
  display: flex;
  position: relative;
  align-items: center;

  ${Input}:checked ~ label & {
    margin-bottom: 6px;
    color: ${giphyCharcoal};
    font-weight: normal;
  }

  &:before {
    position: absolute;
    content: '';
    left: 0;
    width: 0;
    height: 0;

    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid #4e4e4e;
    transition: transform 0.2s ease;

    ${Input}:checked ~ label & {
      transform: rotate(90deg);
    }
  }

  ${({ isActive }) =>
    isActive &&
    css`
      && {
        color: ${giphyLightBlue};
        font-weight: bold;
      }
    `}
`

type DropdownProps = {
  title: string
  children: ReactNode
  isOpen: boolean
  isActive: boolean
}

export default ({ title, children, isOpen, isActive }: DropdownProps) => (
  <>
    <Input id={title} defaultChecked={isOpen} />
    <label htmlFor={title}>
      <Title isActive={isActive}>{title}</Title>
    </label>
    <Wrapper>{children}</Wrapper>
  </>
)
